// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3ocYh","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3eZFv","obliqueLine":"membershipbadge_obliqueLine__ZQrU2"};